import { SxProps } from '@mui/material'
import { FONT_WEIGHTS } from '@/styles'
import { chipClasses, chipColorVariants } from './Chip.data'

interface ChipStyles {
  chip: SxProps
  text: SxProps
}

export const chipStyles: ChipStyles = {
  chip: {
    borderWidth: 1,
    height: 'auto',
    py: 0.25,

    [`.${chipClasses.label}`]: {
      px: 1,
    },
    [`.${chipClasses.icon}`]: {
      mr: 0,
      ml: 0.65,
      width: '12px',
      [`& ~ .${chipClasses.label}`]: {
        pl: 0.25,
      },
    },
    ...buildColorVariantStyles(),
  },
  text: {
    typography: 'textXsSemibold',
    fontWeight: FONT_WEIGHTS.MEDIUM,
    ml: 0,
  },
}

function buildColorVariantStyles(): Record<string, Record<string, unknown>> {
  const styles: Record<string, Record<string, unknown>> = {}
  for (const [name, tokens] of Object.entries(chipColorVariants)) {
    const className = `MuiChip-color${name.charAt(0).toUpperCase()}${name.slice(1)}`
    styles[`&.${className}`] = {
      backgroundColor: tokens.bg,
      [`&.${chipClasses.outlined}`]: {
        borderColor: tokens.border,
      },
      [`.${chipClasses.label}`]: {
        color: tokens.label,
      },
      ...(tokens.icon
        ? {
            [`.${chipClasses.icon}`]: {
              color: tokens.icon,
            },
          }
        : {}),
    }
  }
  return styles
}
